module.exports = __webpack_public_path__ + "static/img/SMSwap.3d1cc0b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/SMSwap.png
// module id = i79K
// module chunks = 0